<template>
  <div class="container mt-5 pt-5">
    <div class="col-lg-12 mb-5 mt-5">
      <h4 class="text-center" v-if="close">
        Payment complete. You may now close the page
      </h4>
      <div id="payment">
        <!-- Elements will create input elements here -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
// eslint-disable-next-line no-unused-vars
import api from '../../api/http-common.js'

export default {
  data() {
    return {
      pubNubMsg: {
        channel: '',
        msg: []
      },
      fortisPaymentResult: null,
      close: false,
      isProcessing: false,
      processedTransactionIds: new Set(),
      elements: null
    }
  },
  computed: {
    ...mapGetters([
      'currentPatientAssociated',
      'getBillingTaskStatement',
      'getProfileAuthInfo',
      'getFacilityInfo',
      'getFortisPaymentForm',
      'getFortisStatementInfo',
      'getFortisPaymentViaUrl'
    ])
  },
  methods: {
    ...mapActions(['setIsLoading']),

    async handlePaymentComplete(result) {
      // Guard against duplicate processing
      if (this.isProcessing) {
        console.log('Payment already being processed, ignoring duplicate event')
        return
      }

      // Guard against duplicate transaction IDs
      if (this.processedTransactionIds.has(result.data.id)) {
        console.log('Transaction already processed:', result.data.id)
        return
      }

      this.isProcessing = true

      try {
        console.log('payment>done')
        console.log('result>', result)

        this.pubNubMsg.channel = this.getFortisPaymentViaUrl.channel
        this.fortisPaymentResult = result

        // Add transaction ID to processed set immediately
        this.processedTransactionIds.add(result.data.id)

        // Update transaction api Id
        await api.patient.request.UpdateFortisTransactionApiId({
          facilityId: this.currentPatientAssociated.facilityID,
          posId: this.getFortisPaymentViaUrl.id,
          transactionId: result.data.id
        })

        var completeResponse = await api.patient.request.fortisTransactionComplete({
          facilityId: this.currentPatientAssociated.facilityID,
          email: this.getFortisPaymentForm.email,
          posId: this.getFortisPaymentViaUrl.id,
          transactionId: this.fortisPaymentResult.data.id,
          taskId: this.getFortisPaymentForm.taskId,
          patientId: this.currentPatientAssociated.patientID
        })

        if (!completeResponse.data.value) {
          this.$swal({
            text: completeResponse.data.reason,
            position: 'top-center',
            title: 'Payment Unsuccessful. Please try again',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2000,
            icon: 'error'
          })
          return
        }

        this.$swal({
          text: completeResponse.data.reason,
          position: 'top-center',
          title: 'Payment',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 2000,
          icon: 'success'
        })

        this.$pnPublish({
          channel: this.getFortisPaymentViaUrl.channel + '-done',
          message: Date.now()
        }, (status, response) => {
          console.log('publish>' + this.getFortisPaymentViaUrl.channel + '-done')
          console.log(status, response)
        })

        this.close = true
      } catch (ex) {
        console.error('Payment processing error:', ex)
        this.$swal({
          text: 'An error occurred during payment processing. Please try again.',
          position: 'top-center',
          title: 'Payment Error',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 3000,
          icon: 'error'
        })
      } finally {
        this.isProcessing = false
      }
    }
  },

  async mounted() {
    // eslint-disable-next-line no-undef
    this.elements = new Commerce.elements(
      this.getFortisPaymentViaUrl.clientToken
    )

    this.elements.create({
      container: '#payment',
      environment: this.getFortisPaymentViaUrl.environment,
      theme: 'default',
      digitalWallets: [],
      fields: {
        billing: [
          { name: 'address', required: true },
          { name: 'postal_code', required: true }
        ]
      }
    })

    this.elements.on('done', this.handlePaymentComplete)
  },

  beforeDestroy() {
    // Clean up event listeners
    if (this.elements) {
      this.elements.off('done', this.handlePaymentComplete)
    }
  }
}
</script>
